import React from 'react';
import { CheckCircle2, AlertTriangle, FileText } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

const unitLabel = (b) => (b.master_carton_no ? `carton ${b.master_carton_no}` : b.box_number);

/** Per-DC loading check: every box of a DC must be on this gate pass (no partial loading). */
export const DcCompletenessCard = ({ rows }) => {
  if (!rows.length) return null;
  return (
    <Card className="border-[#E5DFD0]" data-testid="dc-completeness-card">
      <CardHeader className="pb-3">
        <CardTitle className="text-[#1A1F2E] flex items-center gap-2 text-base">
          <FileText className="w-5 h-5 text-[#2D5F4F]" /> DC loading check
        </CardTitle>
        <p className="text-xs text-gray-500">All boxes of a DC must be loaded together. Partial loading is not allowed.</p>
      </CardHeader>
      <CardContent className="space-y-2">
        {rows.map((g) => {
          const done = g.scanned >= g.boxes.length;
          const missing = [...new Set(g.boxes.filter((b) => !g.scannedSet.has(b.box_number)).map(unitLabel))];
          return (
            <div key={g.dc_number} className={`rounded-lg border p-3 ${done ? 'border-emerald-200 bg-emerald-50' : 'border-amber-300 bg-amber-50'}`}
              data-testid={`dc-row-${g.dc_number}`}>
              <div className="flex items-center justify-between gap-2 flex-wrap">
                <span className="font-mono font-semibold text-sm">{g.dc_number}</span>
                <Badge className={done ? 'bg-emerald-600 hover:bg-emerald-600' : 'bg-amber-500 hover:bg-amber-500'} data-testid={`dc-count-${g.dc_number}`}>
                  {done ? <CheckCircle2 className="w-3.5 h-3.5 mr-1" /> : <AlertTriangle className="w-3.5 h-3.5 mr-1" />}
                  {g.scanned} of {g.boxes.length} boxes scanned
                </Badge>
              </div>
              {g.already_dispatched > 0 && (
                <p className="text-xs text-gray-500 mt-1">{g.already_dispatched} box(es) of this DC already left on an earlier gate pass.</p>
              )}
              {!done && (
                <p className="text-xs text-amber-800 mt-1 break-words" data-testid={`dc-missing-${g.dc_number}`}>
                  Still to scan: {missing.join(', ')}
                </p>
              )}
            </div>
          );
        })}
      </CardContent>
    </Card>
  );
};

export default DcCompletenessCard;
